import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI, companyAPI } from '../../services/api';
import LoadingSpinner from '../Common/LoadingSpinner';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const companyName = 'Schiffer Digital';
  const navigate = useNavigate();

  useEffect(() => {
    // Public endpoint — no auth required. Returns 404 if no logo uploaded yet.
    fetch(companyAPI.logoUrl(), { method: 'HEAD' })
      .then((r) => {
        if (r.ok) setLogoUrl(companyAPI.logoUrl());
      })
      .catch(() => {});
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authAPI.login(formData.email, formData.password);
      const userResponse = await authAPI.getCurrentUser();
      onLogin(userResponse.data);
      toast.success('Anmeldung erfolgreich!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(
        error.response?.data?.detail ||
        'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          {logoUrl && (
            <img src={logoUrl} alt={companyName} className="login-logo" />
          )}
          <h1>{companyName}</h1>
          <h2>Business Center</h2>
          <p>Anmeldung erforderlich</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              E-Mail-Adresse
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="form-input"
              placeholder="E-Mail-Adresse"
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Passwort
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Ihr Passwort"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-full"
            disabled={loading}
          >
            {loading ? (
              <>
                <LoadingSpinner size="small" />
                Anmelden...
              </>
            ) : (
              'Anmelden'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
